import * as z from "zod";
import { RemitMode } from "./remit-mode";

export const remitModeSchema = z.enum(RemitMode);

export const REMIT_MODE_PATH = "redoManagedReturns.remitMode";

export function isRemitModePath(path: string): boolean {
  return path === REMIT_MODE_PATH;
}

/** A cleared value stores AUTOMATIC so readers never fall back to the vestigial Mongo copy. */
export function parseRemitModeValue(value: unknown): RemitMode {
  return value == null ? RemitMode.AUTOMATIC : remitModeSchema.parse(value);
}

export function diffRemitMode(
  stored: RemitMode,
  next: RemitMode | null | undefined,
): { path: string; prev: RemitMode; next: RemitMode }[] {
  if (next == null || stored === next) {
    return [];
  }
  return [{ path: REMIT_MODE_PATH, prev: stored, next }];
}
